import { SnapLayer } from './virutal-layers/snap-layer';
import { ScaleInfo } from './../components/dialogs/scale-and-location-dialog/scale-and-location-dialog';
import { PixoSpatialCoord, SpatialUnits } from './Pixospatial';
// @ts-ignore
import { Map, LngLatBounds, LngLat } from '!mapbox-gl';
import { UUID } from 'angular2-uuid';
import { SLLayer, LayerTypeEnum } from './sl-layer';
import { GeoService } from '../services/geo.service';
import { MapPosition } from '../types/mapposition';
import { ViewContext } from '../types/view-context';
import { BBOX, BBOXArray, DictHandler, IMapMemory, MapMemoryHistory, AnyHandler } from '../types/@types/sl-v-types';
import { NavHistory } from './nav-history';
import { InterruptableTimer } from './interruptabletimer';
import { MapComponent } from '../components/map/map.component';
import { EnvService } from '../env.service';
import { NavEvent, NavEvents } from './NavEvents';
import { Subscription } from 'rxjs';
import { Decorable, Dict } from '../types/decorable';
import { SLProject } from './sl-project';
import { environment } from 'src/environments/environment.dev';
import { ResultsLayer } from './virutal-layers/results-layer';
import { UnSelectedResultsLayer } from './virutal-layers/unselected-results-layer';
import { SelectedResultsLayer } from './virutal-layers/selected-results-layer';
import { ISLMap } from '../types/@types/sl-map';
import { ResultsViewComponent } from '../components/results-view/results-view.component';
import { SLMapMemory } from './sl-map-memory';
import { LayerListProviderService } from '../services/layer-list-provider.service';
import { ModalMessagerService } from '../modal-messager/modal-messager.service';
import { SaveMapDialogService } from '../components/dialogs/save-map-dialog/save-map-dialog-service.';
import { LoadMapDialogService } from '../components/dialogs/load-map-dialog/load-map-dialog-service';
import { MapIOOptions, MapApiService, MapLocation } from './api-services/map-api.service';
import { CancellablePromise } from '../types/cancellable-promise';
import { ResultPopupComponent } from '../components/result-popup/result-popup.component';
import { PanelSetComponent } from '../components/panel-set/panel-set.component';
import { InputLayer } from './virutal-layers/input-layer';
import { InputBufferLayer } from './virutal-layers/input-buffer-layer';
import { ResultsService, ContextState } from '../services/results.service';
import { MapDataAction } from './map-actions/map_data-action';
import { DigitizerComponent } from '../components/attribute-view/digitizer/digitizer.component';
import { EventEmitter } from '@angular/core';
import { AttributeViewComponent } from '../components/attribute-view/attribute-view.component';
import { GeoLocationQualifierService } from './api-services/qualifiers/geo-location-qualifier-service';
import { PixoSpatial } from './Pixospatial';
import { ProjectionService } from './api-services/projection.service';
import { SnapLayerAPIService } from './api-services/snap-layer-api.service';
import { NavigationAction } from './map-actions/navigation-action';
import { SandboxMessengerService, SLMapMessage } from '../services/sandbox-messenger.service';
import { MapTaskSequencer } from './map-task-sequencer';

export type LatLonStyle = 'deg-min-sec' | 'ddeg';

export class SLMap implements ISLMap {
  static POINT_ZOOM = 20;
  static NON_POINT_ZOOM = 15;
  static ZOOM_PADDING = 0;
  static STREET_ZOOM = 18;
  static XSECTN_ZOOM = 20;
  public id: string;
  public layers: Array<SLLayer>;
  public src: any;
  public ui: Map;
  public component: MapComponent;
  public hillShade = false;
  public includeBuildings = false;
  public memory: IMapMemory = new SLMapMemory();
  public memoryHistory: MapMemoryHistory;
  public layerCount = 0;
  public digitizer: DigitizerComponent;
  private isUpdating: boolean;
  private navTimer: InterruptableTimer = new InterruptableTimer(250);
  public hasResults = false;
  public history: NavHistory;
  public historyNaving = false;
  public moving: boolean = false;
  public globalLatLonDefault: LatLonStyle = 'deg-min-sec';
  public snapLayer?: SLLayer;
  public sequencer: MapTaskSequencer;

  resultPopupContent: ResultPopupComponent = null;
  public styles: IResultStyles = {
    selected: '#ffff00;0.50;0.50',
    unselected: '#ff0000;-0.0;0.5',
    resultInput: '#0000ff;0.5;0.5'
  };
  public projectId: number;
  public lastSelections: any;
  public autoZoom = false;
  public baseMapName = '';
  private renderTimer: InterruptableTimer = new InterruptableTimer(250);
  // private isHolding = false;
  private interactionModes: any;
  // private isMoving = false;
  // private isDragging = false;
  // private touched = false;
  // private lastPitch: number;
  private historyEnabled = true;

  private subscriptions: Array<Subscription> = [];
  public project: SLProject;
  private layers3D = { buildings: false, hillshade: false, contour: false, terrain: false };
  private resultsLayer: ResultsLayer;
  private baseMaps: Dict = {
    streets: 'streets-v11',
    light: 'light-v10',
    dark: 'dark-v10',
    outdoors: 'outdoors-v11',
    satstreets: 'satellite-streets-v11'
  };
  private baseMapsOn = {
    streets: false,
    light: false,
    dark: false,
    outdoors: false,
    satstreets: false,
    terrain: false
  };
  get environmentService(): EnvService {
    return this.env;
  }
  get updating(): boolean {
    return this.isUpdating;
  }
  get layerListService() {
    return this.listService;
  }
  get messager() {
    return this.messagerService;
  }
  get searchableLayers(): Array<SLLayer> {
    if (!this.layers) {
      return [];
    }
    return this.listService.GetSearchableLayers(this.layers);
  }
  get capturableLayers(): Array<SLLayer> {
    if (!this.layers) {
      return [];
    }
    return this.listService.GetEditableLayers(this.layers);
  }
  get resultsService(): ResultsService {
    return this.resultsSvc;
  }
  get snapLayerService(): SnapLayerAPIService {
    return this.snapLayerSvc;
  }
  private _inch: number = 0;
  get inch() {
    if (this._inch !== 0) return this._inch;
    const e = document.body.appendChild(document.createElement('DIV'));
    e.style.width = '1in';
    e.style.padding = '0';
    this._inch = e.offsetWidth;
    e.parentNode.removeChild(e);
    return this._inch;
  }
  public scaleUnits: SpatialUnits = 'meters-auto';
  GetMapScale(units: SpatialUnits): ScaleInfo {
    if (!this.ui) return { length: 0, units: units, precisionType: 'auto' };
    const center = this.ui.getCenter();

    if (!this.digitizer.drawPane) {
      if (this._scale) {
        return { length: 0, units: units, precisionType: this._scale.precisionType, precision: this._scale.precision }
      }
      return { length: 0, units: units, precisionType: 'auto' }
    }
    const context = this.digitizer.drawPane.spatialContext;
    const pixoCenter = context.SpatialCoord(center).convert();
    const pxWest = pixoCenter.x - (this.inch / 2.0) - 1.5;
    const pxEast = pixoCenter.x + (this.inch / 2.0) - 1.5;
    const spatialWest = context.PixoPt({ x: pxWest, y: pixoCenter.y }).convert();
    const spatialEast = context.PixoPt({ x: pxEast, y: pixoCenter.y }).convert();
    const scale = context.SpatialDistance(spatialWest, spatialEast, units);
    scale.precisionType = !!this._scale?.precisionType ? this._scale.precisionType : 'auto';
    scale.precision = !!this._scale?.precision ? this._scale.precision : 0;
    scale.pxDistance = pxEast - pxWest;
    return scale;
  }
  GetScalePx(distance: number, units: SpatialUnits) {
    if (!this.ui) return 0;//{ length: 0, units: units };
    const center: LngLat = this.ui.getCenter();
    if (!this.digitizer.drawPane) return 0;
    const context = this.digitizer.drawPane.spatialContext;
    const pixoCenter = context.SpatialCoord(center).convert();
    const west = context.PointAtDistance(center.lng, center.lat, distance / 2.0, units);
    return Math.round((pixoCenter.x - west.x) * 2);
  }
  private _scale?: ScaleInfo;
  SetScale(scale: ScaleInfo) {
    this._scale = scale;
  }

  get scale(): ScaleInfo | undefined {
    return this._scale;
  }

  get isHighDensity(): boolean {
    const rootStyle = getComputedStyle(document.documentElement);
    // Return the value of the specified CSS variable
    return rootStyle.getPropertyValue('--is-high-density').trim() === 'true';
  }
  public layerChange = new EventEmitter<SLMap>();
  private playersLookup: { [key: string]: SLLayer } = {};

  constructor(
    private geoService: GeoService,
    private env: EnvService,
    private listService: LayerListProviderService,
    private messagerService: ModalMessagerService,
    private saveDialogService: SaveMapDialogService,
    private loadDialogService: LoadMapDialogService,
    private mapService: MapApiService,
    private resultsSvc: ResultsService,
    private snapLayerSvc: SnapLayerAPIService,
    private sandboxMsgrSvc: SandboxMessengerService,
    src: any) {
    this.historyEnabled = this.historyEnabled;
    this.id = UUID.UUID();
    this.layers = [];
    this.src = src;
    this.ui = null;
    this.isUpdating = false;
    this.history = new NavHistory(this);
    if (this.historyEnabled === true) { this.history.Enable(); }

    this.subscriptions.push(
      this.history.changes.subscribe(() => {
        for (const layer of this.layers) {
          if (layer.type < LayerTypeEnum.Virtual_Results) {
            layer.Touch();
          }
        }
        this.RenderLayers();
      })
    );
    this.SetNoResults();
    if (!!src.layers3D && !this.env.IsSandboxed()) {
      src.layers3D = this.layers3D;
    }
    if (!!src.baseMapsOn) {
      src.baseMapsOn = this.baseMapsOn;
    }
  }
  SetProjectID(id: number) {
    this.projectId = id;
  }
  SetProject(data: Decorable): SLProject {
    this.project = new SLProject(data);
    this.projectId = Number(this.project.id);
    if (!!this.layers) this.RemoveAllLayers();
    this.MergeStylesFromProject();

    return this.project;
  }
  Merge3DFromProject(project: SLProject = null) {
    if (this.env.IsSandboxed()) return;
    if (project === null) {
      project = this.project;
    }
    this.layers3D.hillshade = (!!project.config.hillshade) ? project.config.hillshade : false;
    this.layers3D.buildings = (!!project.config.buildings) ? project.config.buildings : false;
    this.layers3D.contour = (!!project.config.contour) ? project.config.contour : false;
    if (this.src.extraParams && (this.src.extraParams['3d'])) {
      if (typeof this.src.extraParams['3d'] === 'string') {
        this.src.extraParams['3d'] = [this.src.extraParams['3d']];
      }
      for (const layer3d of this.src.extraParams['3d']) {
        switch (layer3d) {
          case 'hillshade':
            this.layers3D.hillshade = true;
            break;
          case 'contours':
            this.layers3D.contour = true;
            break;
          case 'buildings':
            this.layers3D.buildings = true;
            break;
        }
      }
    }
    this.Update3DLayers();
  }
  MergeLocationFromProject(project: SLProject = null) {
    if (project === null) {
      project = this.project;
    }

    if (!!project.config.location) {
      if (project.config.location.bearing !== 0) {
        if (project.config.location.pitch !== 0) {
          if (!!project.config.location.center) {
            if (!!project.config.location.bearing) {
              if (!!project.config.location.pitch) {
                this.ui.jumpTo({
                  center: project.config.location.center,
                  bearing: project.config.location.bearing,
                  pitch: project.config.location.pitch
                });
              }
            }
          }
        } else {
          if (!!project.config.location.center) {
            this.ui.setCenter(project.config.location.center, { animate: false });
          }
          if (!!project.config.location.bearing) {
            this.ui.setBearing(project.config.location.bearing);
          }
          if (!!project.config.location.pitch) {
            this.ui.setPitch(project.config.location.pitch);
          }
        }
      } else {
        if (!!project.config.location.zoom) {
          this.ui.setZoom(project.config.location.zoom);
        }
        if (!!project.config.location.center) {
          this.ui.setCenter(project.config.location.center, { animate: false });
        }
        if (!!project.config.location.bearing) {
          this.ui.setBearing(project.config.location.bearing);
        }
        if (!!project.config.location.pitch) {
          this.ui.setPitch(project.config.location.pitch);
        }

      }
    } else {
      this.ui.fitBounds(project.bounds, { animate: false });
    }
  }
  MergeBaseMapFromProject(project: SLProject = null) {
    if (project === null) {
      project = this.project;
    }
    this.SetBaseMap(project.config.baseMap);
  }
  MergeStylesFromProject(project: SLProject = null) {
    if (project === null) {
      project = this.project;
    }
    this.styles.selected = project.config.styleSelResults;
    this.styles.unselected = project.config.styleUnselResults;
    if (project.config.hasOwnProperty('resultInput')) {
      this.styles.resultInput = project.config.resultInput;
    }

  }

  EnableHistory(): void {
    this.historyEnabled = true;
  }

  DisableHistory(): void {
    this.historyEnabled = false;
  }

  SetInteractionModes(modes: any): void {
    this.interactionModes = modes;
    this.interactionModes = this.interactionModes;
  }

  SetUI(ui: Map, readyHandler: DictHandler) {
    this.ui = ui;
    this.history.Init();


    setTimeout(() => {
      this.SetupResults(readyHandler);

      this._scale = this.GetMapScale('meters-auto');

    }, 1);


  }

  ClearResult(): void {
    const layer: ResultsLayer = this.GetLayerById('results') as ResultsLayer;
    // layer.ClearResults();
    if (!!this.src.resultsView) {
      (this.src.resultsView as ResultsViewComponent).ShowResults([]);
      this.src.panelSet.CloseExtended();
    }
    this.ClearResults(true);
    //this.SetNoResults();

  }
  ShowResult(data: ContextState): void {
    this.resultsSvc.Synch({
      channel: data.channel,
      data: {
        moment: this.resultsSvc.history.GetMoment(data.channel),
        contextState: (data)
      },
      source: data.context,
      topic: 'result-state-change'
    })
    // const layer: ResultsLayer = this.GetLayerById('results') as ResultsLayer;
    this.resultsSvc.UpdateResultsListSelections(data);
  }
  ShowResults(data: any, selectedLayer: SLLayer = null, selectedFeature: any = null, showInfo: boolean = false): void {
    if (!!this.src.resultsView) {
      (this.src.resultsView as ResultsViewComponent).ShowResults(data.results, selectedLayer, selectedFeature, showInfo);
    }
    if (!!this.src.extendedViews) {
      this.src.extendedViews.SetView('results');
    }
    if (!!this.src.panelSet) {
      this.src.panelSet.OpenExtended();
    }

  }


  SetupResults(readyHandler: DictHandler): void {
    if (!this.ui.loaded()) {
      setTimeout(() => { this.SetupResults(readyHandler); }, 1);
      return;
    }

    this.resultsLayer = new ResultsLayer(this, this.resultsSvc);
    this.resultsLayer.map = this;
    this.AddLayer(this.resultsLayer);
    this.AddLayer(new InputLayer(this, this.resultsSvc));
    this.AddLayer(new InputBufferLayer(this, this.resultsSvc));
    this.AddLayer(new SelectedResultsLayer(this, this.resultsSvc));
    this.AddLayer(new UnSelectedResultsLayer(this, this.resultsSvc));
    // this.AddLayer(new InputLayer(this, this.resultsSvc));

    this.resultsLayer.AddSubLayer(this.layers[1]);
    this.resultsLayer.AddSubLayer(this.layers[2]);
    this.resultsLayer.AddSubLayer(this.layers[3]);
    this.resultsLayer.AddSubLayer(this.layers[4]);
    this.SetupSnapVirtual();
    readyHandler({ map: this });
  }
  SetupSnapVirtual() {
    this.AddLayer(new SnapLayer(this, this.snapLayerService));
  }
  GetSearchLayer(): SLLayer {
    return this.resultsLayer.layer;
  }

  UpdateInitBounds(jumpOpts?: { center?: [number, number], zoom?: number, pitch?: number, bearing?: number }): void {
    if (!jumpOpts) {
      this.MergeLocationFromProject();
      this.component.UpdateInitPosition(this.project.bounds);
      return;
    }
    this.ui.jumpTo(jumpOpts);
    window.requestAnimationFrame(() => {
      this._scale = this.GetMapScale(this.scaleUnits);
    })
    return;
  }
  SetComponent(component: MapComponent): void {
    this.component = component;
    if (this.component.hasOwnProperty('interactions')) {
      this.component.interactions.subscribe((event: any) => {
        for (const mode in event.modes) {
          if (event.modes.hasOwnProperty(mode) === true) {
            if (['zooming', 'panning'].indexOf(mode) > -1) {
              return;
            }
            if (event.modes[mode] === true) {
              this.HandleInteraction(mode, event);
            }
          }

        }
      });
    }

  }
  HandleInteraction(mode: string, event: any) {
    let action = '';
    switch (mode) {
      case 'singleSelecting':
        action = 'info/sel-add';
        break;
      case 'singleDeselecting':
        action = 'info/sel-unsel';
        break;

    }
    if (action !== '') {
      this.component.HandleToolAction({
        action: (action),
        result: event
      });
    }
  }

  AddLayer(layer: SLLayer, isLast = true): void {

    if (layer.type >= LayerTypeEnum.Virtual_Results) {
      this.layerCount += 1;
    } else {
      ProjectionService.RegisterLayerSRS(layer);
    }
    this.layers.push(layer);
    if (layer.isPLayer) {
      this.playersLookup[layer.identifier] = layer;
    }
    if (isLast === true) {
      this.layerChange.emit(this);
    }
  }
  NotifyLayerListeners() {
    this.layerChange.emit(this);
  }
  AddLayersFromProject(_layers?: Array<Decorable>): Array<SLLayer> {
    if (!this.project) {
      return [];
    }
    let i = -1;
    const layers = !!_layers ? _layers : this.project.layers;
    for (const layer of layers) {
      i += 1;
      const slLayer: SLLayer = new SLLayer(layer, this, null, null, this.resultsSvc);
      this.AddLayer(slLayer, false);
      if (slLayer.hasSubLayers) {
        this.AddLayersFromProject(slLayer.subLayers);
      }
    }
    this.layerChange.emit(this);

    return this.layers;
  }
  AddLayerFromProject(layerIndex?: number): SLLayer {
    const layerData = (!!layerIndex) ? this.project.layers[layerIndex] : this.project.layers.slice(-1).pop();
    const slLayer: SLLayer = new SLLayer(layerData, this, this.component.layerAPI, this.component.layersAPI, this.resultsSvc);
    this.AddLayer(slLayer);
    return slLayer;
  }
  GetExtentFromLayers(): BBOXArray {
    const ext: BBOXArray = [190, 100, -190, -100];

    for (const layer of this.layers) {
      const layerExt: Array<number> = layer.bbox;
      if (!layerExt) { continue; }
      ext[0] = Math.max(-180, Math.min(layerExt[0], ext[0]));
      ext[1] = Math.max(-90, Math.min(layerExt[1], ext[1]));
      ext[2] = Math.min(190, Math.max(layerExt[2], ext[2]));
      ext[3] = Math.min(90, Math.max(layerExt[3], ext[3]));
    }
    return ext as BBOXArray;
  }
  MapExtentToBBox(mapBounds: LngLatBounds = null): BBOX {
    let bbox = '';
    const bounds: LngLatBounds = (mapBounds === null) ? this.ui.getBounds() : mapBounds;
    const sw = bounds.getSouthWest();
    const ne = bounds.getNorthEast();
    const minX = Math.min(sw.lng, ne.lng);
    const minY = Math.min(sw.lat, ne.lat);
    const maxX = Math.max(sw.lng, ne.lng);
    const maxY = Math.max(sw.lat, ne.lat);

    bbox += minX + ',' + minY + ',' + maxX + ',' + maxY;
    return bbox as BBOX;
  }
  MapExtentToBBoxArray(mapBounds: LngLatBounds = null): BBOXArray {
    let bbox = '';
    const bounds: LngLatBounds = (mapBounds === null) ? this.ui.getBounds() : mapBounds;
    const sw = bounds.getSouthWest().wrap();
    const ne = bounds.getNorthEast().wrap();
    const minX = Math.min(sw.lng, ne.lng);
    const minY = Math.min(sw.lat, ne.lat);
    const maxX = Math.max(sw.lng, ne.lng);
    const maxY = Math.max(sw.lat, ne.lat);
    return [minX, minY, maxX, maxY];

  }
  GetPitchedMapExtent(context: ViewContext, size?: [number, number]): LngLatBounds {
    if ((this.ui.getBearing() === 0) && this.ui.getPitch() === 0) {
      return context.bounds;
    }
    if (!size) {
      size = this.GetPitchedViewSize(context);
    }
    const halfSize = size[0] / 2.0;
    const halfWidth = context.position.width / 2.0;
    const halfHeight = context.position.height / 2.0;
    const minX = halfWidth - halfSize;
    const minY = halfHeight - halfSize;
    const maxX = halfWidth + halfSize;
    const maxY = halfHeight + halfSize;
    const minLngLat = this.component.spatialContext.PixoPt({ x: minX, y: maxY }).convert();
    const maxLngLat = this.component.spatialContext.PixoPt({ x: maxX, y: minY }).convert();

    return new LngLatBounds([minLngLat, maxLngLat]);


  }
  GetPitchedViewSize(context: ViewContext): [number, number] {
    // const pitchedBounds = this.GetPitchedMapExtent(context);
    if ((this.ui.getBearing() === 0) && this.ui.getPitch() === 0) {
      const pixelDensity = window.devicePixelRatio || 1;
      return [context.position.width / pixelDensity, context.position.height / pixelDensity];
    }
    const sd = Math.min(context.position.width, context.position.height); // smaller dimension
    const ld = Math.max(context.position.width, context.position.height); // larger dimension

    let width: number;
    let height: number;
    width = height = Math.min(Math.max(3 * sd, 1.5 * ld), 4000);

    return [width, height];
  }
  GetPLayerById(id: string): null | SLLayer {
    if (!this.playersLookup) return null;
    if (!this.playersLookup[id]) return null;
    return this.playersLookup[id];
  }
  GetLayerById(id: string, isProjectLayer: boolean = false, _layers?: Array<SLLayer>): SLLayer {
    const layers = !!_layers ? _layers : this.layers;
    for (const layer of this.layers) {
      if (isProjectLayer) {
        if ('' + layer.plid === '' + id) { return layer; }
      } else if ('' + layer.id === '' + id) {
        return layer;
      }
      if (layer.hasSubLayers) {
        // const subMatch = this.GetLayerById(id,isProjectLayer,layer.subSLLayers);
        // if(!!subMatch) return subMatch;
      }
    }
  }
  GetLayersCenter(): LngLat {
    return this.geoService.BBoxToLngLatBounds(this.GetExtentFromLayers())?.getCenter();
  }
  GetLayerBounds(): LngLatBounds {
    return this.geoService.BBoxToLngLatBounds(this.GetExtentFromLayers());
  }
  GetCenter(): LngLat {

    return this.ui.getCenter();
  }

  get currentViewState(): ViewContext {
    const startPosition: MapPosition = this.viewPosition;
    if (!!this.ui) {
      this.SetViewPosition({
        location: {
          center: this.GetCenter(),
          zoom: startPosition.location.zoom,
          bearing: 0,
          pitch: 0,
        },
        width: startPosition.width,
        height: startPosition.height


      }, NavEvents.NewInternal('viewstate/set-un-oriented'));

      const mapBounds = this.ui.getBounds();

      this.SetViewPosition(startPosition, NavEvents.NewInternal('viewstate/set-oriented'));

      return {
        bbox: this.geoService.LngLatBoundsToBBoxArray(mapBounds),
        bounds: mapBounds,
        position: startPosition
      };
    } else {
      return {
        bbox: [-180, -90, 180, 90],
        bounds: this.geoService.BBoxToLngLatBounds([-180, -90, 180, 90]),
        position: this.viewPosition
      };
    }
  }
  /*set currentViewState(context: ViewContext) {
    this.viewPosition = context.position;
    this.ui.fitBounds(context.bounds, { animate: false });
  }*/
  SetViewState(context: ViewContext, changeContext: NavEvent): void {
    this.ui.jumpTo(context.position.location, changeContext);
    setTimeout(() => {
      this.ui.setBearing(context.position.location.bearing, changeContext);
      this.ui.setZoom(context.position.location.zoom, changeContext);
    }, 5);
  }
  get viewPosition(): MapPosition {
    if (this.ui === null) {
      return {
        location: {
          center: new LngLat(0, 0),
          pitch: 0,
          bearing: 0,
          zoom: 13
        },
        width: window.innerWidth,
        height: window.innerHeight
      };
    }
    const position: MapPosition = {
      location: {
        center: this.ui.getCenter(),
        pitch: this.ui.getPitch(),
        bearing: this.ui.getBearing(),
        zoom: this.ui.getZoom(),
      },
      width: this.ui.getCanvas().width,
      height: this.ui.getCanvas().height
    };
    return position;
  }


  SetViewPosition(position: MapPosition, event: NavEvent): void {

    this.ui.jumpTo(position.location, event);
    this.ui.setBearing(position.location.bearing, event);
    this.ui.setZoom(position.location.zoom, event);
  }

  InitBaseMap(): void {

    setTimeout(() => {
      let baseMap = (!this.project.config.baseMap && (this.project.config.baseMap !== '')) ? 'satstreets' : this.project.config.baseMap;
      if (!!this.src.extraParams) {
        if (!!this.src.extraParams.bg) {
          baseMap = this.src.extraParams.bg;
        }
      }
      this.src.baseMapsOn[baseMap] = true;
      this.SetBaseMap(baseMap, true);
      setTimeout(() => {
        this.Update3DLayers();

      }, 3000);
    }, 1);
  }
  SetBaseMap(baseMapName: string = 'null', initial = false): void {


    if (baseMapName === null) {
      baseMapName = (!this.project.config.baseMap && (this.project.config.baseMap !== '')) ? 'satstreets' : this.project.config.baseMap;

    }

    if (!this.ui.isStyleLoaded()) {
      window.requestAnimationFrame(() => {
        this.SetBaseMap(baseMapName, initial);
      });
      return;
    }
    let wasOn = this.baseMapsOn[baseMapName];
    if (initial === true) {
      wasOn = false;
    }
    this.baseMapsOn[baseMapName] = true; // !this.baseMapsOn[baseMapName];
    for (const name in this.baseMapsOn) {
      if (this.baseMapsOn.hasOwnProperty(name)) {
        this.baseMapsOn[name] = wasOn ? false : (name === baseMapName);
      }
    }
    if (!!this.src.baseMapsOn) {
      this.baseMapsOn = this.src.baseMapsOn;
    }
    if (this.ui.getLayer('basemap')) {
      this.ui.removeLayer('basemap');
      this.ui.removeSource('basemap');
    }
    this.baseMapName = baseMapName;
    if (baseMapName === '') {
      return;
    }
    if (!this.baseMaps[baseMapName] || !this.baseMapsOn[baseMapName]) {
      return;
    }

    const src = 'https://api.mapbox.com/styles/v1/mapbox/'
      + this.baseMaps[baseMapName]
      + '/tiles/{z}/{x}/{y}?access_token='
      + environment.mapbox.accessToken;

    this.ui.addLayer({
      id: 'basemap',
      source: {
        type: 'raster',
        tiles: [src],
        tileSize: 512
      },
      type: 'raster',
      layout: { visibility: 'visible' }
    });
    if (this.layers.length > 0) {
      if (!!this.ui) {
        this.ui.moveLayer('basemap', 'L' + this.layers[this.layers.length - 1].identifier);
      }
    }
    this.Update3DLayers();
    const emptyAttrib = document.getElementsByClassName('mapboxgl-attrib-empty');
    if (emptyAttrib.length > 0) {
      emptyAttrib[0].classList.toggle('mapboxgl-attrib-empty');
    }

  }



  Update3DLayers(): void {

    this.ui.moveLayer('mapbox-terrain-rgb');
    this.ui.moveLayer('contour');
    this.ui.moveLayer('contour-label');
    this.ui.moveLayer('building-outline');
    this.ui.moveLayer('building');

    this.ui.setLayoutProperty('building', 'visibility', this.layers3D.buildings ? 'visible' : 'none');
    this.ui.setLayoutProperty('building-outline', 'visibility', this.layers3D.buildings ? 'visible' : 'none');
    this.ui.setLayoutProperty('mapbox-terrain-rgb', 'visibility', this.layers3D.hillshade ? 'visible' : 'none');
    this.ui.setLayoutProperty('contour', 'visibility', this.layers3D.contour ? 'visible' : 'none');
    this.ui.setLayoutProperty('contour-label', 'visibility', this.layers3D.contour ? 'visible' : 'none');
    this.ui.setTerrain({ source: 'mapbox-dem', exaggeration: this.layers3D.terrain ? 1.25 : 0, 'visible': this.layers3D.terrain });
    //this.ui.setLayoutProperty('sky', 'visibility', this.layers3D.terrain ? 'visible' : 'none');
    if (!!this.src.layers3D) {
      this.src.layers3D = this.layers3D;
    }
  }


  ToggleBuildings(notify: boolean = true): void {
    notify = notify;
    this.layers3D.buildings = !this.layers3D.buildings;
    this.Update3DLayers();
  }
  ToggleTerrain(notify: boolean = true, onOff?: boolean): void {
    notify = notify;
    if (onOff === undefined) {
      this.layers3D.terrain = !this.layers3D.terrain;;
    } else {
      this.layers3D.terrain = onOff;
    }
    if (this.layers3D.terrain === true) {
      if (onOff === undefined) {
        this.ui.setPitch(45);
      }
    }
    if (!this.ui.isStyleLoaded()) return;
    this.ui.setTerrain({ source: 'mapbox-dem', exaggeration: this.layers3D.terrain ? 1.25 : 0, 'visible': this.layers3D.terrain });

  }
  ToggleHillShade(notify: boolean = true): void {
    notify = notify;
    this.layers3D.hillshade = !this.layers3D.hillshade;
    this.Update3DLayers();
  }

  ToggleContour(notify: boolean = true): void {
    notify = notify;
    this.layers3D.contour = !this.layers3D.contour;
    this.Update3DLayers();
  }

  GetMapUILayerID(layer: SLLayer) {
    if (!layer) return undefined;
    if (layer === undefined) return undefined;
    if (layer?.identifier === undefined) return undefined;
    if (!isNaN(parseInt(layer.identifier.substring(0, 1)))) {
      return 'L' + layer.identifier;
    } else {
      return layer.identifier;
    }
  }
  UpdateLayerOrder() {
    // Fix ME

    let counter = 0;
    let hasBaseMap = false;
    if (this.baseMapName !== '') {
      for (const item in this.baseMapsOn) {
        if (this.baseMapsOn.hasOwnProperty(item)) {
          hasBaseMap = this.baseMapsOn[item];
          if (hasBaseMap === true) { break; }
        }
      }
    }
    for (const layer of this.layers) {
      if (counter === 0) {
        if (hasBaseMap === true) {
          this.ui.moveLayer(this.GetMapUILayerID(layer), 'basemap');
        } else {
          this.ui.moveLayer(this.GetMapUILayerID(layer));
        }
      } else {
        this.ui.moveLayer(this.GetMapUILayerID(layer), this.GetMapUILayerID(this.layers[counter - 1]));
      }
      counter += 1;
    }
    if (hasBaseMap === true) {
      this.ui.moveLayer('basemap', this.GetMapUILayerID(this.layers[this.layers.length - 1]));
    }
    this.Update3DLayers();
    return;
  }
  ReAddLayers(layers: Array<SLLayer> = null, id: string = null) {
    const i = 0;
    for (const layer of this.layers) {
      layer.overlayLayer.SetupLayer();
      if (i > 0) {
        this.ui.moveLayer(this.GetMapUILayerID(layer), this.GetMapUILayerID(layers[i - 1]));
      } else {
        if (id !== null) {
          this.ui.moveLayer(this.GetMapUILayerID(layer), id);
        } else {
          this.ui.moveLayer(this.GetMapUILayerID(layer));
        }
      }
      if (layer.hasSubLayers === true) {
        this.ReAddLayers(layer.subLayers, this.GetMapUILayerID(layer));
      }
    }
  }
  RemoveAllLayers(includeResults: boolean = false) {
    const leftOvers = [];
    for (const layer of this.layers) {
      if (layer.type >= LayerTypeEnum.Virtual_Results) {
        if (!includeResults) {
          leftOvers.push(layer);
          continue;
        }
      }
      layer.Remove();
    }
    this.layers = leftOvers.slice(0);
    this.layerCount = this.layers.length;
    this.layerChange.emit(this);
  }

  RefreshLayers(): void {
    for (const layer of this.layers) {
      layer.Render(this);
    }
  }
  RenderLayers(): void {
    if (this.navTimer.isSampling === true) {
      this.navTimer.Interrupt();
    } else {
      this.navTimer.Start(() => {

        for (const layer of this.layers) {
          layer.Render(this);
        }
        this.navTimer.Stop();
      });
    }

  }
  RenderResults(): void {
    this.renderTimer.Start(() => {
      const layer: ResultsLayer = this.GetLayerById('results') as ResultsLayer;
      layer.Render();
      this.renderTimer.Stop();
    });
  }

  Destroy() {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }

  MoveTo(fromId: any, toId: any = null, layers: Array<SLLayer> = null) {
    if (layers === null) {
      layers = this.layers;
    }
    const from = this.GetLayerById(fromId, layers[0].isPLayer);
    const fromIndex = layers.indexOf(from);
    let toIndex = -1;
    if (from.parentLayer !== '') {
      if (toId === 'end') {
        const parent = from.parentSLLayer;
        toId = parent.subLayers[parent.subLayers.length - 1].identifier;
      }
    }

    if ((toId !== null) && (toId !== undefined)) {
      const to = this.GetLayerById(toId, from.isPLayer);
      toIndex = layers.indexOf(to);
    }
    if (toIndex === -1) {
      this.layers.splice(fromIndex, 1);
      this.layers.push(from);

    } else if (toIndex > fromIndex) {
      this.layers.splice(toIndex, 0, from);
      this.layers.splice(fromIndex, 1);
    } else {
      this.layers.splice(fromIndex, 1);
      this.layers.splice(toIndex, 0, from);
    }
    this.MoveChildren(from, toId);
    this.UpdateLayerOrder();


  }
  MoveChildren(parentLayer: SLLayer, toId: any) {
    if (parentLayer.hasSubLayers === false) {
      return;
    }
    for (const layer of parentLayer.subSLLayers) {
      this.MoveTo(layer.identifier, toId);
      this.MoveChildren(layer, toId);
    }
  }
  ShowQueryResults(result: any, asResults = false, params: any = {}) {
    params = params;
    let targetAction = 'info/show-query-results';
    if (asResults === false) {
      if (this.component.IsInteracting('tooltipping')) {
        if (this.src.queryToResults === false) {
          targetAction = 'info/show-tooltip';
        }
      } else if (this.component.IsInteracting('roiQuerying')) {
        // this.resultsSvc.SetResults(result.results, 'roi-query', params, 'layer/query', params.bufferSrc, true);
        if (this.src.queryToResults) {
          if (!!this.src.resultsView) {
            // (this.src.resultsView as ResultsViewComponent).ShowResults(result.results);
            this.src.panelSet.OpenExtended();

          }
          if (!!this.src.extendedViews) {
            this.src.extendedViews.SetView('results');
          }
        } else if (this.src.queryToInfo) {
          this.src.SetSecondaryView('attribute');
        }
        return;
      }

      if (!this.component.IsInteracting('tooltipping')) {
        if (!this.component.IsInteracting('querying')) {
          return;
        }
      }
      // this.resultsSvc.SetResults(result.results, 'query', params, 'layer/query', params.bufferSrc, true);
      this.component.HandleToolAction({
        action: targetAction,
        result: (!!result.moment) ? result.moment : result.results
      });
      return;
    }
    this.component.HandleToolAction({
      action: targetAction,
      result: (result)

    });
    /*
    if (!!this.src.panelSet) {
      this.src.panelSet.OpenExtended();
    }
    if (!!this.src.extendedViews) {
      this.src.extendedViews.SetView('results');
    }*/
    this.SetHasResults();
  }
  GetResultsViewResults(handler: AnyHandler) {
    this.component.HandleToolAction({
      action: 'info/get-results-view-results',
      callBack: (handler)
    });
  }
  ShowResultsView() {
    this.src.panelSet.OpenExtended('results');
    this.SetHasResults();

  }
  UpdateQuerySelections(info: any) {
    if (!!this.src.resultsView) {
      this.src.resultsView.UpdateSelections(info);
      this.lastSelections = info;
    }
  }
  ShowQueryInResults(data: any): void {
    if (!!this.src.resultsView) {

      const id = (!!data.selectedLayer) ? data.selectedLayer.id : null;
      const selectedFeature = (!!data.selectedFeature) ? data.selectedFeature : null;

      /*(this.src.resultsView as ResultsViewComponent).ShowResultMoment(
        this.resultsSvc.history.latest,
        id,
        selectedFeature
      );*/
      this.src.resultsView.selectedLayer = id;
      this.src.resultsView.selectedFeature = selectedFeature;

      if (!!this.src.ToggleClass) {
        this.SetHasResults();
      }
    }
    if (!!this.src.extendedViews) {
      this.src.extendedViews.SetView('results');
    }
    if (!!this.src.panelSet) {
      (this.src.panelSet as PanelSetComponent).OpenExtended();
    }
  }
  AppendResults(data: any): void {
    if (!!this.src.resultsView) {
      this.SetHasResults();

      (this.src.resultsView as ResultsViewComponent).AppendResults(data);
    }
  }
  ExcludeResults(data: any): void {
    if (!!this.src.resultsView) {
      console.log(data);
      if (!!this.src.ToggleClass) {
        this.SetHasResults();
      }
      this.src.resultsView.ExcludeResults(data);
    }
  }

  ClearPUCResults() {
    this.resultsSvc.history.synchResultsSet['popup-control'] = null;
    // this.resultsLayer.ClearResults();
    this.ClearResults(true);
  }

  ClearResults(clearResultsLayer: boolean = false): void {
    let count = 0;
    let synchCount = 0;
    for (const key in this.resultsSvc.history.synchResultsSet) {
      if (this.resultsSvc.history.synchResultsSet.hasOwnProperty(key) === false) continue;
      count += 1;
      if (this.resultsSvc.history.synchResultsSet[key] !== null) synchCount += 1;
    }
    if (synchCount === 0) {
      this.SetNoResults();
      this.SetHasResults(false);

    } else {
      this.hasResults = true;
      this.resultsLayer.RefreshIf(this.resultsLayer.layer);
    }

  }

  SetHasResults(onOrOff = true): void {
    this.hasResults = onOrOff;
    if (!!this.src.ToggleClass) {
      this.src.ToggleClass('has-results', this.hasResults);
      this.src.ToggleClass('no-results', !this.hasResults);
    }
    if (!!this.src.resultsView) {
      if (this.autoZoom === true) {
        setTimeout(() => {
          (this.src.resultsView as ResultsViewComponent).HandleZoomToAction({ zoomToToolsAction: 'zoom-to-all' });
        }, 5000);
      }
    }

    if (!!this.src.layerView) {
      this.src.layerView.stylesVisible = false;
    }

    this.src.panelSet.UpdatePanels();
    window.requestAnimationFrame(() => {
      if (this.resultsLayer) {
        if (!this.hasResults) this.resultsLayer.ClearResults();
      }
    })
  }
  SetNoResults(): void {
    this.hasResults = false;
    if (!!this.src.ToggleClass) {
      this.src.ToggleClass('has-results', false);
      this.src.ToggleClass('no-results', true);
    }
  }
  ResetSelectMode() {
    if (!!this.src.resultsView) {
      (this.src.resultsView as ResultsViewComponent).ResetSelectMode();
    }
  }
  SetSelecting(onOrOff: boolean) {
    this.src.ToggleClass('selecting', onOrOff);
  }
  HasResultsView(): boolean {
    if (!!this.src.resultsView) {
      return true;
    }
    return false;
  }
  UpdateResults() {
    this.resultsLayer.Render(this);
  }
  SetDigitizerLayer(layer: SLLayer) {
    this.component.SetDigitizerLayer(layer);
    if (!!this.src.SetDigitizerLayer) {
      this.src.SetDigitizerLayer(layer);
    }
  }
  SetSnapLayer(layer?: SLLayer) {
    if (!layer) {
      this.digitizer?.drawPane?.GetSnaps()?.points?.Clear();
      this.digitizer?.drawPane?.GetSnaps()?.segments?.Clear();
    }
    this.snapLayer = layer;
  }
  UpdateSelections() {
    if (!!this.layers) {
      if (this.layers.length > 0) {
        if (this.layers[0].name === 'Search Results') {
          this.layers[0].Render();
        }
      }
    }
  }
  Update(layer: SLLayer) {
    for (const lyr of this.layers) {
      if (lyr.id === layer.id) {
        lyr.Render();
      }
    }
    this.UpdateSelections();
  }
  SavePrompt(handler: AnyHandler): void {
    this.saveDialogService.Show(handler, this);
  }
  LoadPrompt(handler: AnyHandler): void {
    this.loadDialogService.Show(handler, this);
  }
  Save(options: MapIOOptions): CancellablePromise {
    return this.mapService.SaveMap(this, options);
  }
  Load(options: MapIOOptions): CancellablePromise {
    return this.mapService.ReLoadMap(this, options);
  }
  DecorateBaseMap(mergeObject: any): void {
    let baseMap = '';
    for (const key in this.baseMapsOn) {
      if (this.baseMapsOn.hasOwnProperty(key)) {
        if (this.baseMapsOn[key] === true) {
          baseMap += (baseMap.length > 0) ? ',' : '';
          baseMap += key;
        }
      }
    }
    mergeObject.baseMap = baseMap;

  }
  Decorate3D(mergeObject: any): void {
    for (const key in this.layers3D) {
      if (this.layers3D.hasOwnProperty(key)) {
        mergeObject[key] = this.layers3D[key];
      }
    }
  }
  DecorateLocation(mergeObject: any): void {
    const mapLoc: MapLocation = {
      center: this.ui.getCenter(),
      zoom: this.ui.getZoom(),
      bearing: this.ui.getBearing(),
      pitch: this.ui.getPitch()
    };
    mergeObject.location = mapLoc;
  }
  DecorateExtents(mergeObject: any): void {
    const bbox: BBOX = this.MapExtentToBBox(this.ui.getBounds());
    const container: HTMLElement = this.ui.getContainer();
    const width = container.offsetWidth;
    const height = container.offsetHeight;
    mergeObject.bbox = bbox;
    mergeObject.windowsize = width + ',' + height;

  }
  DecorateSelStyles(mergeObject: any): void {
    if (mergeObject.hasOwnProperty('styleUnselColor')) {
      delete mergeObject.styleUnselColor;
    }
    if (mergeObject.hasOwnProperty('styleUnselColor')) {
      delete mergeObject.styleSelColor;
    }
    mergeObject.styleUnselResults = this.styles.unselected;
    mergeObject.styleSelResults = this.styles.selected;
    mergeObject.resultInput = this.styles.resultInput;
  }
  DecorateLegacy(mergeObject: any): void {
    if (!(!!mergeObject.bgcolor)) {
      mergeObject.bgcolor = 0xFFFFFF;
    }
    if (!(!!mergeObject.useCheckers)) {
      mergeObject.useCheckers = false;
    }
  }
  DecorateLayers(mergeObject: any, includeSettings: boolean = false): void {
    const layers = [] as Array<any>;
    for (const layer of this.layers) {
      if (layer.type >= LayerTypeEnum.Virtual_Results) {
        continue;
      }
      const entry: any = { plid: layer.plid };
      if (includeSettings === true) {
        layer.DecorateSettings(entry);
      }
      layers.push(entry);
    }
    mergeObject.layers = JSON.stringify(layers);
  }
  RemoveMapLayer(plid: string) {
    let i = -1;
    for (const layer of this.layers) {
      i++;
      if (layer.plid === plid) {
        this.layers.splice(i, 1);
        return;
      }
    }

  }
  OpenPrimary(view?: string) {
    if (!!this.src.primaryViews) {
      if (!!view) {
        this.src.primaryViews.SetView(view);
      }
    }
    if (!!this.src.panelSet) {
      (this.src.panelSet as PanelSetComponent).OpenPrimary();
    }
  }
  ClosePrimary() {
    if (!!this.src.panelSet) {
      (this.src.panelSet as PanelSetComponent).ClosePrimary();
    }
  }
  OpenSecondary(view?: string) {
    if (!!this.src.secondaryViews) {
      if (!!view) {
        this.src.secondaryViews.SetView(view);
      }
    }
    if (!!this.src.panelSet) {
      (this.src.panelSet as PanelSetComponent).OpenSecondary();
    }
  }
  CloseSecondary() {
    if (!!this.src.panelSet) {
      (this.src.panelSet as PanelSetComponent).CloseSecondary();
    }
  }

  OpenExtended(view: string) {
    if (!!this.src.extendedViews) {
      this.src.extendedViews.SetView(view);
    }
    if (!!this.src.panelSet) {
      (this.src.panelSet as PanelSetComponent).OpenExtended();
    }
  }
  CloseExtended() {
    if (!!this.src.panelSet) {
      (this.src.panelSet as PanelSetComponent).CloseExtended();
    }
  }
  GoToSearch(layer: SLLayer): void {
    MapDataAction.Exec('search-toggle', this.component, { selected: true });
    if (!!this.src.searchView) {
      this.src.searchView.SelectLayer(layer);
    }
    this.src.panelSet.OpenPrimary();
    this.src.searchView.ToggleTreeVis(true);

  }
  GoToLayer(layer: SLLayer): void {
    MapDataAction.Exec('layers-toggle', this.component, { selected: true });
    if (!!this.src.layersView) {
      this.src.layersView.ShowSLLayer(layer);
    }
  }
  ShowInfo() {
    if (!!this.src.SetSecondaryView) {
      MapDataAction.Exec('legend-toggle', this.component, { selected: false });
      this.src.panelSet.OpenSecondary();
      this.src.SetSecondaryView('attribute', true);

    }
  }
  ToggleGlobalLatLonDefault(which?) {
    if (!which) {
      this.globalLatLonDefault;
      switch (this.globalLatLonDefault) {
        case 'ddeg':
          this.globalLatLonDefault = 'deg-min-sec';
          break;
        case 'deg-min-sec':
          this.globalLatLonDefault = 'ddeg';
          break;
      }
    } else {
      this.globalLatLonDefault = which;
    }
    GeoLocationQualifierService.SetDegreeFormat(this.globalLatLonDefault);
    if (this.src && this.src.attributeView) {
      this.src.attributeView.LatLonFormatChanged();
    }
    if (this.src && this.src.resultsView) {
      this.src.resultsView.LatLonFormatChanged();
    }


  }
  DigitizerUpdated() {
    if (this.src.hasOwnProperty('attributeView')) {
      //(this.src.attributeView as AttributeViewComponent).vertexTools.DigitizerUpdated();

    }
  }
  UpdateStyledLayers() {
    for (const layer of this.layers) {
      if (layer.type < LayerTypeEnum.Virtual) {
        break;
      }
      if (layer.type === LayerTypeEnum.Virtual_Results) {
        continue;
      }
      layer.UpdateLegend();
    }
    this.RenderResults();
  }
  RefreshResultsIfLayer(ifLayer: SLLayer) {
    for (const layer of this.layers) {
      if (layer.type === LayerTypeEnum.Virtual_Results) {
        (layer as any).RefreshIf(ifLayer);
      }
    }
  }
  GetUsedSRSes(): Dict {
    const srses: Dict = {};
    const reservedEPSG: Array<number> = [4326, 3857];
    for (const layer of this.layers) {
      if (layer.type >= LayerTypeEnum.Virtual) {
        continue;
      }
      const srsName = layer.srsName;
      let skip = false;
      for (const reserved of reservedEPSG) {

        if (layer.srs.toString().toLowerCase().indexOf(`\"epsg\",\"${reserved}\"`) > -1) {
          skip = true;
          continue;
        }
      }
      if (skip) continue;
      if (!srses[srsName]) {
        (srses as Decorable)[srsName] = layer.srs;
      }
    }
    return srses;
  }
  SendSandboxMessage(subject: string, data: any) {
    const message = this.sandboxMsgrSvc.MakeMessage(subject, data);
    this.sandboxMsgrSvc.SendMessage(message);
  }
}
